export {
  HYBRID_CODE_SERVICE_FEATURE_FLAG,
  INTERNAL_NETWORK_PENTEST_FEATURE_FLAG,
  PERMISSIONS,
  PERMISSION_DEFINITIONS,
  PERMISSION_HIERARCHY,
  ROLES,
  ROLE_DEFINITIONS,
  TENANT_ADMIN_PERMISSIONS,
  getImpliedPermissions,
  getOpenIdDefaultPermissions,
  getPermissionsForRoles,
  hasSatisfyingPermission,
  isValidPermission,
  isValidRole,
  permissionSatisfies,
  resolveOpenIdEffectivePermissions,
  resolveUserPermissions,
} from './lib/permissions';
export type {
  AuthFeatureFlagKey,
  Permission,
  PermissionKey,
  Role,
  RoleDefinition,
} from './lib/permissions';
export {
  hasEvaluationExecutePermission,
  hasEvaluationReadPermission,
} from './lib/evaluation-execute-permission';
export {
  EvaluationTenantAccessError,
  assertEvaluationSourceTenantAccess,
} from './lib/evaluation-tenant-access';
export type { EvaluationSourceTenantAccessInput } from './lib/evaluation-tenant-access';
export {
  FEATURE_FLAG_GATED_AUTH_FLAG_KEYS,
  isAuthInfraEnabledForFlag,
  resolvePermissionDefinitionsForSync,
  resolveRoleDefinitionsForSync,
} from './lib/auth-sync';
export type {
  FeatureFlagGatedAuthFlagKey,
  PermissionDefinitionForSync,
} from './lib/auth-sync';
export { defineMetadata, getRoutePermissions } from './lib/contract-metadata';
export type { ContractMetadata } from './lib/contract-metadata';
export { uploadedFileSchema, uploadedFilesSchema } from './lib/multipart';
export {
  TERRA_ORPC_ROUTE_METADATA_KEY,
  terraContract,
} from './lib/orpc-contract';
export {
  AUTH_CONTEXT_TOKEN_TYPE_ACCESS_KEY,
  AUTH_CONTEXT_TOKEN_TYPE_USER,
  DEFAULT_AUTH_PROVIDER,
  DESCOPE_JWT_TYPE_ACCESS_KEY,
  LOCAL_DEFAULT_TENANT_ID,
  LOCAL_DEFAULT_TENANT_NAME,
} from './lib/types';
export type {
  AuthContextTokenType,
  AuthProviderType,
  JWTTokenPayload,
} from './lib/types';
export {
  isDescopeAccessKeyJwtType,
  toAuthContextTokenType,
  toJwtTokenPayloadType,
} from './lib/descope-jwt';
